import BackgroundMobileView from './mobile/Background.mobile.view.tsx';
import BackgroundDesktopView from './desktop/Background.desktop.view.tsx';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function BackgroundView() {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <BackgroundMobileView />}
      {isDesktop && <BackgroundDesktopView />}
    </>
  );
}
